import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs';
import { UserService } from '../services/user.service';
import { NotifyService } from '../services/notify.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnDestroy {
  loginForm!: FormGroup;
  private _alive: boolean = true;
  loginErrorMessage: string = '';
  submitting: boolean = false;
  type: string = 'password';
  eyeOpen: boolean = false;

  public readonly TOKEN = 'auth'

  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    private _notify: NotifyService
  ) {
    //localStorage.clear()
    //console.log(_userService.getTokenDetails.User_Role)
    if (_userService.getToken) {
      let userRole = _userService.getTokenDetails.User_Role
      if (userRole === 'DPNF ADMIN') {
        _router.navigate(['/admin/analytics'])
      } else if (userRole === 'EXPLORER') {
        _router.navigate(['/dpnf/master-search'])
      } else {
        _router.navigate(['query/master-search'])
      }
    } else {
      localStorage.clear()
      sessionStorage.clear();
    }
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required]
    });
  }

  onEyeClose() {
    this.type = 'text';
    this.eyeOpen = true;
  }

  onEyeOpen() {
    this.type = 'password';
    this.eyeOpen = false;
  }

  login() {
    this.submitting = true;
    this._userService
      .login(this.loginForm.value)
      .pipe(takeWhile(() => this._alive))
      .subscribe({
        next: (res) => {
          console.log(res)
          localStorage.setItem('userName', res.User_Name);
          localStorage.setItem('totalRemaining', res.total_remaining);
          localStorage.setItem('totalEffort', res.total_effort);
          localStorage.setItem('totalFound', res.total_found);
          localStorage.setItem('todayEffort', res.today_effort);
          localStorage.setItem('todayFound', res.today_found);
          localStorage.setItem('email', this.loginForm.value.email);
          sessionStorage.setItem(this.TOKEN, String(res.token))

          if (res.User_Role === 'DPNF ADMIN')
            this._router.navigate(['/admin/analytics']);
          if (res.User_Role === 'EXPLORER')
            this._router.navigate(['/dpnf/master-search']);
          if (res.User_Role === 'VOYAGER')
            this._router.navigate(['/query/master-search']);
        },
        error: (err) => {
          this.submitting = false;
          //console.log(this.submitting)
          this._notify.error('Login Error', err.error?.message)
        }
      });
  }

  ngOnDestroy() {
    this._alive = false;
  }
}
